import React, { Fragment, useEffect, useMemo, useState } from 'react';
import * as Yup from 'yup';
import moment from 'moment';
//import { endOfDay } from 'date-fns';
import { withFormik, FieldArray } from 'formik';
import queryString from 'query-string';
import {
  getObjFromLS,
  checkError,
  setObjInLS,
  restRequest,
  getDate,
} from '../../Helpers';
import { getOrganizationDate } from '../../Helpers';
import {
  required,
  ValidateDate,
  ValidateMax255,
  ValidateMax50,
  ValidateNumber,
  ValidateRequired,
  ValidateNumerMoreThenZero,
} from '../../Helpers/Validator';
import {
  Field,
  Form,
  FormSection,
  FormAction,
  ErrorFocus,
} from '../../Components/Form/index';
import {
  formSubmit,
  //getError,
  validate,
} from '../../Components/Form/FormHelper';
import { CustomModal, Loader } from '../../Components';
import Customer from '../Contact/ContactDetails/index';
import {
  NewContactIcon,
  NewInvoiceIcon,
} from '../../Assets/Navigation/NavigationIcons';
import InvoiceDetails from '../SalesOrder/Invoices/InvoiceDetails';
import AddContact from '../Contact/AddContact';
//import InvoicesFilter from './InvoicesFilter';
import { validateCustomerpaymentForm } from '../../Helpers/FormValidator';
import useMobileDetection from '../../Hooks/MobileDetect';
import './index.css';
import { ImInfo, MdHelpOutline } from '../../Common/Icons';
import { useTranslation } from 'react-i18next';
import { GoArrowSwitch } from 'react-icons/go';
import AddCurrency from '../Currency/AddCurrency';
import { t } from 'i18next';
import { ToolTip } from '../../Common';
import { debounce } from 'lodash';
import { toTwoDecimal } from '../../Api/Invoice/Utils';
import { TbInfoSquareFilled } from 'react-icons/tb';

// let allValls = [];

// let confirm = false;
const getYupValidationSchema = (values) => {
  return Yup.object().shape({
    contactId: required(ValidateNumber),
    paymentId: ValidateRequired,
    amount_received: ValidateNumerMoreThenZero,
    paymentDate: required(ValidateDate),
    reference: ValidateMax50,
    customerNotes: ValidateMax255,
    payment_mode: required(ValidateMax255),

    // items: Yup.array()
    //   .of(
    //     Yup.lazy((item) => {
    //       return Yup.object().shape({
    //         name: ValidateRequired,
    //         quantity: required(
    //           moreThanZero(ValidateMax10Billion).integer('Invalid Value')
    //         ),
    //         unitPrice: required(moreThanMinus(ValidateMax10Billion)),
    //         discount:
    //           item.discountType === 'percent'
    //             ? ValidateMax100Number
    //             : ValidateAmountNumber(
    //                 item.discount,
    //                 item.quantity * item.unitPrice
    //               ),
    //       });
    //     })
    //   )
    //   .min(1, 'At least one item is required'),
  });
};

const formEnhancer = withFormik({
  validate: validate(getYupValidationSchema),
  mapPropsToValues: (props) => {
    return {
      saveAndSend: false,
      saveAndPrint: false,
      customerNotes: props.customerNotes,
      reference: props.reference,
      advancePaymentId: props.advancePaymentId,
      amount_received: props.amount_received,
      refund_amount: props.refund_amount,
      contactId: props.contactId,
      invoiceList: props.invoiceList,
      paymentDate: props.paymentDate,
      paymentId: props.paymentId,
      payment_mode: props.payment_mode,
      payment_mode_name: props.payment_mode_name,
      contactObj: props.contactObj,
      globalCurrency: props.globalCurrency,
      exchangeRate: props.exchangeRate,
      total_received_full_amount: props.total_received_full_amount,
      fullAmountRec: false,
    };
  },
  mapPropsToStatus: (props) => ({
    showContactCreateModal: false,
    ...props,
  }),
  handleSubmit: (values, bag) => {
    sessionStorage.setItem('showPrint', false);
    handleFormSubmit(values, bag);
  },
});
const handleFormSubmit = (
  values,
  {
    setSubmitting,
    props: {
      id,
      submitRequestType,
      submitRequestUrl,
      successMessage,
      type,
      history,
      handleToast,
      setPrompt,
    },
  }
) => {
  const payload = {
    customer_id: values.contactId,
    id: values.advancePaymentId,
    payment_no: values.paymentId,
    payment_date:
      values.paymentDate && values.paymentDate.format('YYYY-MM-DD 00:00:00'),
    payment: toTwoDecimal(values.amount_received),
    reference: values.reference,
    payment_mode: values.payment_mode_name,
    note: values.customerNotes,
    refund_amount: toTwoDecimal(values.refund_amount),
    fullAmountRec: values.fullAmountRec,
    final_exchange_amount: values.fullAmountRec
      ? (values.exchangeRate || 1) *
        toTwoDecimal(values.total_received_full_amount)
      : toTwoDecimal(values.amount_received * (values.exchangeRate || 1)),
    invoices: values.invoiceList
      .filter((item) => item.payment > 0)
      .map((item) => ({
        invoice_id: item.id,
        payment: toTwoDecimal(item.payment),
        exchange_rate: item.exchange_rate,
        exchanged_payment: toTwoDecimal(
          toTwoDecimal(toTwoDecimal(item.payment) / (item.exchange_rate || 1)) *
            (values.exchangeRate || 1)
        ),
      })),
    used_amount: toTwoDecimal(
      values?.invoiceList?.reduce(
        (total, val) =>
          val.payment
            ? total +
              toTwoDecimal(
                toTwoDecimal(
                  toTwoDecimal(val.payment) / (val.exchange_rate || 1)
                ) * (values.exchangeRate || 1)
              )
            : total,
        0
      ) || 0
    ),

    exchange_rate: values.exchangeRate || 1,
    currency_id: values.globalCurrency,
    exchanged_payment: toTwoDecimal(
      values.amount_received * (values.exchangeRate || 1)
    ),
  };

  let checkpayment = values.fullAmountRec
    ? (values.exchangeRate || 1) *
      toTwoDecimal(values.total_received_full_amount)
    : toTwoDecimal(values.amount_received) * (values.exchangeRate || 1);

  let invoicePayment = payload?.invoices?.reduce(
    (total, val) => total + val.exchanged_payment,
    0
  );

  if (Math.floor(checkpayment) < Math.floor(invoicePayment)) {
    handleToast(
      'Applied payment on invoice is greater than Payment total',
      'error'
    );
    setSubmitting(false);
    return;
  }
  restRequest(submitRequestType(), submitRequestUrl(), payload)
    .then((res) => {
      setPrompt(false);
      successMessage();
      if (values.saveAndSend) {
        history.push(
          `/paymentsmade/email/${res.data.advance_payment.payment_no}`
        );
      } else if (values.saveAndPrint) {
        sessionStorage.setItem('showPrint', true);
        sessionStorage.setItem(
          'showPrintId',
          res.data.advance_payment.payment_no
        );
        let dataFromLS = getObjFromLS('module');
        setObjInLS('module', {
          ...dataFromLS,
          moduleName: 'paymentsmade',
          urlPath: `/paymentsmade/`,
          showPrint: true,
          action: type === 'add' ? 'add' : 'justedit',
          queryParam: dataFromLS.queryParam ? dataFromLS.queryParam : '',
        });
        return history.push('/r');
      } else {
        let dataFromLS = getObjFromLS('module');
        if (type === 'add') {
          setObjInLS('module', {
            ...dataFromLS,
            id: res.data.advance_payment.payment_no,
            moduleName: 'paymentsmade',
            urlPath: '/paymentsmade',
            action: type === 'add' ? 'add' : 'justedit',
            queryParam: '',
          });
        }
        if (type === 'edit') {
          setObjInLS('module', {
            ...dataFromLS,
            id: parseInt(res.data.advance_payment.payment_no),
            moduleName: 'paymentsmade',
            urlPath: '/paymentsmade',
            action: type === 'add' ? 'add' : 'justedit',
            queryParam: dataFromLS.queryParam ? dataFromLS.queryParam : '',
          });
        }
        history.push('/r');

        // history.push('/r');
        sessionStorage.setItem('fullscreen', false);
      }
    })
    .catch((error) => {
      setSubmitting(false);
      checkError(error);
      handleToast(error, 'error');
    });
};

const ReceivedPaymentFormEnhancer = ({
  // props from formik
  values,
  status,
  handleSubmit,
  handleChange,
  handleBlur,
  setFieldValue,
  setStatus,
  setValues,
  isSubmitting,
  errors,
  touched,
  setFieldTouched,
  t,
  disabled,

  // custom props
  type,
  organizationCurrency,
  currency_list,
  customerList,
  newItem,
  history,
  handleToast,
  updateCustomerList,
  invoiceList,
  total_received_full_amount,
  cofirmState,
  ...props
}) => {
  const [showPrompt, setShowPrompt] = useState(false);
  const [staticVal, setStaticValues] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [invoiceId, setInvoiceId] = useState();
  const [fullAmountRec, setFullAmountRec] = useState(false);
  const [dateRangeModal, setDataRangeModal] = useState(false);
  const [SubmittingState, setSubmittingState] = useState(false);
  const [comingFromContact, setComingFromContact] = useState(false);
  const [loading, setLoading] = useState(false);
  const [disableCheck, setDisableCheck] = useState(false);
  const [invoiceFilterDate, setInvoiceFilterDate] = useState({
    startDate: moment(getOrganizationDate()),
    endDate: moment(getOrganizationDate()),
    displayDateText: `(${t('Payments.date_filter')})`,
  });
  const [dateRangeLoader, setDteRangeLoader] = useState(false);
  const [preSelectedInvoices, setPreSelectedInvoices] = useState([]);
  const [currentCustomer, setCurrentCustomer] = useState({});
  const [currencyList, setCurrencyList] = useState(currency_list || []);
  const [current_currency, setCurrentCurrency] = useState();
  // const [total_received_full_amount, setTotalReceivedFullAmount] =
  //   useState(0.0);

  let permissions = getObjFromLS('role').permissions;

  useEffect(() => {
    setCurrentCurrency(
      currencyList.find((currency) => currency.id === values.globalCurrency)
    );
    if (fullAmountRec) {
      handleReceivedAmount({
        target: { checked: true },
      });
    }
  }, [values.globalCurrency, values.exchangeRate]);

  const [hasMobile] = useMobileDetection();
  // const { t } = useTranslation();
  /*const [filters, setFilters] = useState({
    dateRange: {
      selection: {
        startDate: moment(getOrganizationDate()).subtract(7, 'days'),
        endDate: moment(endOfDay(getOrganizationDate())),
        key: 'selection',
      },
    },
  });*/

  useEffect(() => {
    handleAlert();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values, staticVal]);

  useEffect(() => {
    setStaticValues(values);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const { contactId = null } = queryString.parse(window.location.search);
    if (contactId) {
      customerChangeHandler(+contactId, 'from_contacts');
      // setComingFromContact(true);
      setLoading(true);
    }
  }, []);

  useEffect(() => {
    if (type === 'edit') {
      let preSelectedItems = invoiceList.filter(
        (item) => item.payment && item.payment > 0
      );
      setPreSelectedInvoices(preSelectedItems);
      if (total_received_full_amount == values.amount_received) {
        setFullAmountRec(true);
      }
      let val = [...values.invoiceList];
      let list = val.map((val) => ({
        ...val,
        payment: val.exchanged_payment_made,
        // amount_received: parseFloat(
        //   val.exchanged_payment_made
        // ).toFixed(2),
      }));
      let receivedfullAmount = values?.total_received_full_amount;

      setValues({
        ...values,
        // amount_received: parseFloat(
        //   exchanged_payment_made
        // ).toFixed(2),
        invoiceList: list,
      });
    }
  }, []);

  // useEffect(() => {
  //   if (type === 'edit') {
  //     setFieldValue('_payment_mode', props.payment_mode_name);
  //   } else if (type === 'add') {
  //     setFieldValue('_payment_mode', props.payment_mode_name);
  //   }

  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  const handleAlert = () => {
    let { checkout } = validateCustomerpaymentForm(values, staticVal);
    if (!checkout) props.setPrompt();
    else props.setPrompt(false);
  };

  const handlePaymentChange = (option) => {
    let isNewOption = !status.paymentMethods.find(
      (method) => method.name === option.label
    );
    if (!isNewOption) {
      setFieldValue('payment_mode', option.id);
      setFieldValue('payment_mode_name', option.name);
    }
  };

  const [, setShowMergeModal] = useState(false);

  useEffect(() => {
    return () => {
      // allValls = [];
      setShowMergeModal(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [loadingItem] = useState(false);

  const handleItemQuantityChange = (quantityValue, index) => {
    let quantity = quantityValue.floatValue;
    let itemList = [...values.invoiceList];
    let currentItem = itemList[index];
    itemList[index] = { ...currentItem, payment: quantity };
    setFieldValue('invoiceList', itemList);
    const checkExist = itemList.some(
      (item) => item.exchanged_payment_due < item.payment
    );
    // if (checkExist) {
    //   setSubmittingState(true);
    // } else {
    //   checkPriceValidator(itemList);
    // }
  };

  const checkPriceValidator = (itemList) => {
    const invoiceAmount = (
      itemList.reduce(
        (total, val) => (val.payment ? total + val.payment : total + 0),
        0
      ) || 0
    ).toFixed(2);

    const totalPayment = values.amount_received
      ? parseFloat(values.amount_received).toFixed(2)
      : 0;
    if (Number(invoiceAmount + values.refund_amount) > Number(totalPayment)) {
      setSubmittingState(true);
    } else {
      setSubmittingState(false);
    }
  };

  const checkAmountValidator = (itemList, amount_received) => {
    const invoiceAmount = (
      itemList.reduce(
        (total, val) => (val.payment ? total + val.payment : total + 0),
        0
      ) || 0
    ).toFixed(2);

    const totalPayment = amount_received
      ? parseFloat(amount_received).toFixed(2)
      : 0;
    if (Number(invoiceAmount + values.refund_amount) > Number(totalPayment)) {
      setSubmittingState(true);
    } else {
      setSubmittingState(false);
    }
  };

  // function handleSaveAndSend(event, submitFlag) {
  //   setFieldValue('saveAndSend', true);
  //   if (submitFlag === false || submitFlag === undefined) {
  //     event.preventDefault();
  //     setShowMergeModal(true);
  //   } else {
  //     return formSubmit(
  //       event,
  //       values.items,
  //       setFieldValue,
  //       handleSubmit
  //       // wareId
  //     );
  //   }
  // }

  const closeModal = () => {
    setShowModal(false);
    setStatus({
      ...status,
      showContactCreateModal: false,
      showCurrencyCreateModal: false,
    });
  };

  const viewInvoiceModal = () => {
    return (
      <CustomModal
        Icon={NewInvoiceIcon}
        showModal={showModal}
        title={t('Invoice.view_invoice')}
        renderActions={false}
        size="large"
        onClose={closeModal}
        linkTo={`invoices/${invoiceId}`}
        classNames="so_view_invoices"
      >
        <InvoiceDetails id={invoiceId} inModal />
      </CustomModal>
    );
  };

  /*const handleDateRangeChange = (payload) => {
    setFilters({
      ...filters,
      dateRange: {
        selection: {
          startDate: moment(payload.selection.startDate),
          endDate: moment(endOfDay(payload.selection.endDate)),
          key: 'selection',
        },
      },
    });
  };*/

  const dateRangeFilterHandler = (reset) => {
    if (invoiceFilterDate?.startDate > invoiceFilterDate?.endDate) {
      handleToast(
        '"Start Date" should be smaller than or equal to the "End Date"',
        'error'
      );
      return;
    }
    setDteRangeLoader(true);
    let preSelectedItems = [];

    if (values.invoiceList.length && type === 'add') {
      preSelectedItems = values.invoiceList.filter(
        (item) => item.payment && item.payment > 0
      );
    } else if (values.invoiceList.length && type === 'edit') {
      let preSelectedIds = preSelectedInvoices.map((item) => item.id);
      preSelectedItems = values.invoiceList.filter(
        (item) =>
          preSelectedIds.includes(item.id) || (item.payment && item.payment > 0)
      );
    }

    let displayDateText = `(${getDate(
      invoiceFilterDate.startDate
    )} -  ${getDate(invoiceFilterDate.endDate)})`;

    setInvoiceFilterDate({
      ...invoiceFilterDate,
      displayDateText: displayDateText,
    });

    setDataRangeModal(false);
    let apiURl = `advancepayment/search?customer_id=${
      values.contactId
    }&start=${invoiceFilterDate.startDate.format(
      'YYYY-MM-DD 00:00:00'
    )}&end=${invoiceFilterDate.endDate.format('YYYY-MM-DD 23:59:59')}`;
    if (reset === 'reset') {
      apiURl = `advancepayment/search?customer_id=${values.contactId}`;
      let resetFilterDate = {
        startDate: moment(getOrganizationDate()),
        endDate: moment(getOrganizationDate()),
        displayDateText: `(${t('Payments.date_filter')})`,
      };
      setInvoiceFilterDate(resetFilterDate);
    }

    restRequest('get', apiURl)
      .then((res) => {
        if (res.length) {
          let preSelectedIds = preSelectedItems.map((item) => item.id);
          let unMatchedInvoices = res.filter((item) => {
            return !preSelectedIds.includes(item.id);
          });
          let allinvoices = [...preSelectedItems, ...unMatchedInvoices];
          setValues({
            ...values,
            //amount_received: 0,
            invoiceList: allinvoices,
          });
        } else {
          setValues({
            ...values,
            // amount_received: 0,
            invoiceList: preSelectedItems,
          });
        }
        setDteRangeLoader(false);
      })
      .catch((error) => {
        setDteRangeLoader(false);
        checkError(error);
        handleToast(error, 'error');
      });
  };
  const dateRangeFilter = () => {
    return (
      <CustomModal
        TItleClass="payment-popup"
        Icon={NewInvoiceIcon}
        showModal={dateRangeModal}
        title={t('Payments.select_date_range')}
        renderActions={true}
        size="large"
        onClose={() => {
          setDataRangeModal(false);
        }}
        classNames="so_view_invoices"
        onSubmit={dateRangeFilterHandler}
        confirmLabel={t('Payments.apply')}
      >
        <div className="date-range-filters">
          <Field
            className="inline-field so_feilds"
            type="date"
            size="large"
            name={t('Payments.start_date')}
            value={invoiceFilterDate.startDate}
            id="startDate"
            handleChange={(date) => {
              invoiceDateFilterHandler(date, 'startDate');
            }}
          />
          <Field
            className="inline-field so_feilds"
            type="date"
            size="large"
            name={t('Payments.end_date')}
            minDate={invoiceFilterDate.startDate}
            value={invoiceFilterDate.endDate}
            id="endDate"
            handleChange={(date) => {
              invoiceDateFilterHandler(date, 'endDate');
            }}
          />
        </div>

        {/* <InvoicesFilter
          dateRange={{
            value: filters.dateRange,
            onChange: handleDateRangeChange,
          }}
          clickHandler={dateRangeFilterHandler}
        /> */}
      </CustomModal>
    );
  };

  const payFullHandler = (index) => {
    const updatedList = values.invoiceList.map((singleInvoice, i) => {
      return index === i
        ? { ...singleInvoice, payment: singleInvoice.exchanged_payment_due }
        : singleInvoice;
    });
    setFieldValue('invoiceList', updatedList);
  };

  const handleError = (index) => {
    if (values.invoiceList[index].exchanged_payment_due === 0) {
      const value =
        (touched &&
          values.invoiceList.length !== 0 &&
          values.invoiceList[index].id &&
          parseFloat(values.invoiceList[index].payment) >
            parseFloat(values.invoiceList[index].exchanged_payment_due) +
              parseFloat(values.invoiceList[index].total)) ||
        parseFloat(values.invoiceList[index].payment) >
          parseFloat(values.amount_received);
      setSubmittingState(!!value);
      return value;
    }
    const value =
      touched &&
      values.invoiceList.length !== 0 &&
      values.invoiceList[index].id &&
      parseFloat(values.invoiceList[index].payment) >
        parseFloat(values.invoiceList[index].exchanged_payment_due);
    setSubmittingState(!!value);

    return value;
  };

  const handleArrowsKey = (e, index) => {
    if (e.key === 'ArrowDown' && index + 1 < values?.invoiceList?.length) {
      const element = document.getElementById(
        `${values.invoiceList[index + 1].id}`
      );
      setTimeout(() => {
        element.select();
        element.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }, 100);
    }
  };
  const handleArrowUpKey = (e, index) => {
    if (e.key === 'ArrowUp' && index - 1 >= 0) {
      const element = document.getElementById(
        `${values.invoiceList[index - 1].id}`
      );
      element.select();
      element.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
  };

  // const totalPayments = values?.invoiceList.reduce((sum, invoice) => {
  //   return sum + (invoice.payment || 0); // Add payment if exists, otherwise 0
  // }, 0);

  // const totalPaymentsBasecurrency = values?.invoiceList.reduce(
  //   (sum, invoice) => {
  //     return sum + (invoice.payment / invoice.exchange_rate || 0); // Add payment if exists, otherwise 0
  //   },
  //   0
  // );

  const totalPaymentsSelectedCurrency = values?.invoiceList.reduce(
    (sum, invoice, index) => {
      const payment =
        invoice?.payment === '' || invoice?.payment == null
          ? 0
          : invoice?.payment;
      return (
        sum +
        toTwoDecimal(
          toTwoDecimal(payment / (invoice.exchange_rate || 1)) *
            (values.exchangeRate || 1)
        )
      ); // Add payment if exists, otherwise 0
    },
    0
  );

  const getExchangeCalculationTooltip = ({
    payment = 0,
    rate = 1,
    exchangeRate = 1,
  }) => {
    const step1Raw = payment / rate;
    const step1 = toTwoDecimal(step1Raw);

    const step2Raw = step1 * exchangeRate;
    const finalValue = toTwoDecimal(step2Raw);

    return `Step 1: ${toTwoDecimal(payment)} / ${rate} = ${step1}
Step 2: ${step1} × ${exchangeRate} = ${toTwoDecimal(step2Raw)}
Step 3: Final → ${finalValue}`;
  };

  function renderList() {
    return (
      <FieldArray
        name="items"
        render={() => {
          return (
            <div className="so-tbletabs">
              <table className={`w-100 customer-payment-table`}>
                <thead>
                  <tr>
                    <th>{t(`Payments.date`)}</th>
                    <th>{t(`Payments.invoice_no`)}</th>
                    <th className="right-align">{t(`Payments.amount`)}</th>
                    <th className="right-align">{t(`Payments.amount_due`)}</th>
                    {/* <th className="right-align">
                      {t(`Payments.exchange_rate`)}
                    </th> */}
                    <th className="right-align">{t(`Payments.payment`)}</th>
                    {/* <th className="right-align">
                      Changed Amount in {organizationCurrency?.name}
                    </th> */}
                    <th className="right-align">
                      Payment in {current_currency?.name}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {values.invoiceList.length !== 0 ? (
                    values.invoiceList?.map((item, index) => {
                      return (
                        <tr key={index} className="">
                          <td className="">
                            <span>{getDate(item?.invoice_date)}</span>
                          </td>
                          <td className="">
                            <span
                              className="item_view_click_btn"
                              onClick={() => {
                                setInvoiceId(item.id);
                                setShowModal(true);
                              }}
                            >
                              {item.invoice_no}
                            </span>
                          </td>
                          <td className="right-align">
                            <span>{`${item?.currency?.symbol}${parseFloat(
                              item.exchanged_total
                            ).toFixed(2)}`}</span>
                            {organizationCurrency.id !== item?.currency?.id &&
                              organizationCurrency?.is_base_currency && (
                                <p style={{ fontSize: 10 }}>
                                  exchange{' '}
                                  <b>
                                    @:{item?.currency?.symbol}
                                    {parseFloat(item.exchange_rate)}
                                  </b>
                                </p>
                              )}
                          </td>
                          <td className="right-align">
                            <span>{`${item?.currency?.symbol}${parseFloat(
                              item.exchanged_payment_due
                            ).toFixed(2)}`}</span>
                          </td>
                          {/* <td className="right-align">
                            <span>{`${item?.currency?.symbol}${parseFloat(
                              item.exchange_rate
                            )?.toFixed(2)}`}</span>
                          </td> */}
                          <td className="right-align">
                            <div className="field-pay">
                              <Field
                                size="small"
                                type="number"
                                value={item?.payment}
                                placeholder={`${item?.currency?.symbol}0`}
                                decimalScale={2}
                                id={values.invoiceList[index].id}
                                allowNegative={false}
                                thousandSeparator=","
                                onValueChange={(value) =>
                                  handleItemQuantityChange(value, index)
                                }
                                removeValueOnClick
                                error={handleError(index)}
                                onBlur={handleBlur}
                                onKeyDown={(e) => handleArrowsKey(e, index)}
                                onKeyUp={(e) => handleArrowUpKey(e, index)}
                              />
                              <small
                                onClick={() => payFullHandler(index)}
                                className="payFullbtn"
                              >
                                {t('Packages.pay_in_full')}
                              </small>
                            </div>
                          </td>

                          <td className="right-align">
                            <span>
                              {`${getcurrencysymble()}${toTwoDecimal(
                                toTwoDecimal(
                                  toTwoDecimal(item?.payment ?? 0) /
                                    (item?.exchange_rate || 1)
                                ) * (values?.exchangeRate ?? 1)
                              )}`}
                            </span>
                            &nbsp;
                            {(toTwoDecimal(item?.payment ?? 0) /
                              (item?.exchange_rate || 1)) *
                              (values?.exchangeRate ?? 1) >
                              0 && (
                              <ToolTip
                                content={getExchangeCalculationTooltip({
                                  payment: item?.payment,
                                  rate: item?.exchange_rate,
                                  exchangeRate: values?.exchangeRate,
                                })}
                              >
                                <TbInfoSquareFilled />
                              </ToolTip>
                            )}
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr className="no-record">
                      <td colSpan={5} style={{ padding: '10px' }}>
                        {t('Invoice.invoices_not_found')}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          );
        }}
      />
    );
  }

  const getExcessAmmount = () => {
    let amountReceived = values.amount_received
      ? parseFloat(values.amount_received) * (values.exchangeRate || 1)
      : 0;

    // // let Payments = values?.invoiceList?.reduce(
    // //   (total, val) => (val.payment ? total + val.payment : total + 0),
    // //   0
    // // );
    let Payments = totalPaymentsSelectedCurrency;

    let refundAmount = values.refund_amount ? values.refund_amount : 0;
    let total = amountReceived - (Payments + refundAmount);

    return total.toFixed(2);
  };

  const renderSummary = () => {
    let currencySymbol = organizationCurrency?.symbol || '$';
    return (
      <>
        <div className="cust-table-summary">
          <div className="w-40 left-col">
            {/* <span>Applied Invoices:&nbsp;0</span> */}
          </div>
          <div className="w-30 right-col">
            <div className="single-summary-rec mb-6">
              <span className="">{t(`Payments.amount_received`)} </span>
              <span className="semi-bold">
                {`${getcurrencysymble()}${
                  values.amount_received
                    ? (
                        parseFloat(values.amount_received) *
                        (values.exchangeRate || 1)
                      ).toFixed(2)
                    : parseFloat(0).toFixed(2)
                }`}
              </span>
            </div>

            <div className="single-summary-rec mb-6">
              <span className="">{t(`Payments.amount_used_for_payments`)}</span>
              <span className="semi-bold">{`${getcurrencysymble()}${toTwoDecimal(
                totalPaymentsSelectedCurrency
              )}`}</span>
            </div>
            <div className="single-summary-rec border-top">
              <span className="">
                <strong>{t(`Payments.refund_amount`)}</strong>
              </span>
              <span className="semi-bold">
                {`${getcurrencysymble()}` +
                  parseFloat(values.refund_amount)?.toFixed(2)}
              </span>
            </div>
            <div className="single-summary-rec border-top">
              <span className="">
                <strong>{t(`Payments.amount_in_excess`)}</strong>
              </span>
              <span className="semi-bold">
                {' '}
                {parseFloat(getExcessAmmount()) < 0
                  ? `-${getcurrencysymble()}${Math.abs(
                      parseFloat(getExcessAmmount())
                    ).toFixed(2)}`
                  : `${getcurrencysymble()}${parseFloat(
                      getExcessAmmount()
                    ).toFixed(2)}`}
              </span>
            </div>
          </div>
        </div>
        <hr />
        <hr />
        <div style={{ color: '#ccc', marginTop: '7px' }}>
          **List contains only SENT invoices
        </div>
      </>
    );
  };

  const renderModals = () => {
    return (
      <Fragment>
        {contactCreateModal()}
        {viewInvoiceModal()}
        {dateRangeFilter()}
        {currencyCreateModal()}
        {showCustomerModal && contactDeatilModal()}
      </Fragment>
    );
  };

  const handleClearAmount = (e) => {
    e.preventDefault();
    const list = [...values.invoiceList];
    let updatedList = list.map((val) => ({ ...val, payment: '' }));
    setFieldValue('invoiceList', updatedList);
  };

  let submitFlag = true;
  const [stopRequest, setstopRequest] = useState(false);
  const [showCustomerModal, setShowCustomerModal] = useState(false);
  const [customerId, setCustomerId] = useState('');
  const handleCustomerModal = (id) => {
    setCustomerId(id);
    setShowCustomerModal(true);
  };

  const handleCurrencyCreateSubmit = async (currency) => {
    const newCurrencyOption = {
      value: currency.id,
      label: `${currency.currency_code} - ${currency.symbol} - ${currency.name}`,
      exchange_rate: currency.exchange_rate,
    };

    setCurrencyList((prevList) => [
      ...prevList,
      {
        ...currency,
        value: currency.id,
        label: `${currency.currency_code} - ${currency.symbol} - ${currency.name}`,
        exchange_rate: currency.exchange_rate,
        previous_exchange_rate: 0,
      },
    ]);

    setValues({
      ...values,
      globalCurrency: newCurrencyOption.value,
      exchangeRate: currency.exchange_rate || 1,
    });
  };

  const currencyCreateModal = () => {
    return (
      <CustomModal
        size="medium"
        showModal={status.showCurrencyCreateModal}
        title="Add Currency"
        renderActions={false}
        onClose={closeModal}
        showPrompt={(showPrompt) => handlePrompt(showPrompt)}
      >
        <AddCurrency
          handleToast={handleToast}
          closeEditmodal={closeModal}
          onSubmit={(res) => handleCurrencyCreateSubmit(res?.data)}
          fromInvoice={true}

          // fetchDataWithQueryString={() => this.fetchDataWithQueryString()}
        />
      </CustomModal>
    );
  };
  const contactDeatilModal = () => {
    return (
      <CustomModal
        size="large"
        className="contacts_modal_view"
        showModal={showCustomerModal}
        title={t('Invoice.view_contact')}
        modaltitle="inventory_modal_title"
        Icon={NewContactIcon}
        renderActions={false}
        onClose={() => setShowCustomerModal(false)}
        linkTo={`contacts/${customerId && customerId}`}
      >
        <Customer id={customerId && customerId} inModal={true} />
      </CustomModal>
    );
  };
  const handleReceivedAmount = ({ target }) => {
    setFullAmountRec(target.checked);
    if (target.checked) {
      let val = [...values.invoiceList];
      let list = val.map((val) => ({
        ...val,
        payment: val.exchanged_payment_due,
      }));
      // let receivedfullAmount = values?.invoiceList?.reduce(
      //   (total, val) => total + val.exchanged_payment_due,
      //   0
      // );
      let receivedfullAmount = values?.total_received_full_amount;
      setValues({
        ...values,
        amount_received: parseFloat(
          receivedfullAmount
          // + values.refund_amount
        ),
        invoiceList: list,
        fullAmountRec: true,
      });
      // if (receivedfullAmount <= 0 || receivedfullAmount === undefined) {
      //   setSubmittingState(true);
      // } else {
      checkAmountValidator(list, receivedfullAmount);
      // }
    } else {
      let val = [...values.invoiceList];
      let list = val.map((val) => ({ ...val, payment: '' }));
      setValues({
        ...values,
        // amount_received: 0,
        invoiceList: list,
        fullAmountRec: false,
      });
    }
  };

  const customerChangeHandler = (contactId = null, from = '') => {
    if (contactId) {
      setDteRangeLoader(true);
      restRequest(
        'get',
        `advancepayment/invoice/create?customer_id=${contactId}`
      )
        .then((res) => {
          setLoading(false);
          if (from) {
            const newCustomer = res?.customer_list[0];
            const old_obj = {
              id: newCustomer.id,
              display_name: newCustomer.display_name,
            };

            const { id: value, display_name: label, ...rest } = old_obj;
            const new_customer = { value, label, ...newCustomer };
            setCurrentCustomer(new_customer);
            updateCustomerList(newCustomer);
          }
          setValues({
            ...values,
            // amount_received: null,
            invoiceList: res.invoices,
            contactId: contactId,
            total_received_full_amount: res.received_full_amount,
          });
          setDisableCheck(res.disabled);
          setFullAmountRec(false);
          setDteRangeLoader(false);
          let resetFilterDate = {
            startDate: moment(getOrganizationDate()),
            endDate: moment(getOrganizationDate()),
            displayDateText: `(${t('Payments.date_filter')})`,
          };
          setInvoiceFilterDate(resetFilterDate);
        })
        .catch((error) => {
          setDteRangeLoader(false);
          checkError(error);
          handleToast(error, 'error');
        });
    } else {
      setValues({
        ...values,
        amount_received: '',
        customerNotes: '',
        invoiceList: [],
        contactId: null,
      });
      setFullAmountRec(false);
      let resetFilterDate = {
        startDate: moment(getOrganizationDate()),
        endDate: moment(getOrganizationDate()),
        displayDateText: `(${t('Payments.date_filter')})`,
      };
      setInvoiceFilterDate(resetFilterDate);
    }
  };
  // Date Filter
  const invoiceDateFilterHandler = (date, type) => {
    if (!date) return;
    const datefilter = {
      ...invoiceFilterDate,
      [type]: date,
    };
    setInvoiceFilterDate(datefilter);
  };

  // Date Filter end

  const handleContactCreateSubmit = (newCustomer) => {
    const old_obj = {
      id: newCustomer.id,
      display_name: newCustomer.display_name,
    };

    const { id: value, display_name: label, ...rest } = old_obj;
    const new_customer = { value, label, ...newCustomer };
    setCurrentCustomer(new_customer);
    updateCustomerList(newCustomer);
    customerChangeHandler(newCustomer?.id);
    setStatus({
      ...status,
      showContactCreateModal: false,
    });
  };
  function handleSaveAndSend(event, submitFlag) {
    setFieldValue('saveAndSend', true);
    if (submitFlag === false || submitFlag === undefined) {
      event.preventDefault();
      // setShowMergeModal(true);
    } else {
      let dataFromLS = getObjFromLS('module');
      if (type === 'add') {
        setObjInLS('module', {
          ...dataFromLS,
          // id: res.data.advance_payment.payment_no,
          moduleName: 'paymentsmade',
          urlPath: '/paymentsmade',
          action: type === 'add' ? 'add' : 'justedit',
          queryParam: '',
        });
      }
      // setTimeout(() => {
      return formSubmit(event, [], setFieldValue, handleSubmit);
      // }, 1);
    }
  }
  function handleSaveAndPrint(event, submitFlag) {
    setFieldValue('saveAndPrint', true);
    if (submitFlag === false) {
      event.preventDefault();
    } else {
      // setTimeout(() => {
      return formSubmit(event, [], setFieldValue, handleSubmit);
      // }, 1);
    }
  }
  const handlePrompt = (status = true) => {
    setShowPrompt(status);
  };

  const contactCreateModal = () => {
    return (
      <CustomModal
        size="large"
        showModal={status.showContactCreateModal}
        title="Add Contact"
        customWidth="contact-modal-width"
        renderActions={false}
        onClose={closeModal}
        showPrompt={showPrompt}
      >
        <AddContact
          type="purchaseOrder"
          inModal
          close={closeModal}
          onSubmit={(res) => handleContactCreateSubmit(res.data)}
          handleToast={handleToast}
          contactTypeId={2}
          handlePrompt={handlePrompt}
        />
      </CustomModal>
    );
  };

  const handleAdjustmentChange = (adjustmentValue) => {
    let adjustment = adjustmentValue.floatValue;
    if (adjustment > 0) {
      let adjustmentString = adjustment.toString();

      if (adjustmentString.length > 10) {
        // adjustmentString = adjustmentString.slice(0, 10);
        // update to 14 for getting value after decimal points
        adjustmentString = adjustmentString.slice(0, 14);
      }
      adjustment = parseFloat(adjustmentString);
      // Convert from selected currency to base currency by dividing by exchange rate
      const baseAmount = adjustment / (values.exchangeRate || 1);
      // Store with higher precision to avoid rounding errors when multiplying back
      setFieldValue('amount_received', baseAmount);
    } else {
      setFieldValue('amount_received', adjustment);
    }
    // if (adjustment <= 0 || adjustment === undefined) {
    //   setSubmittingState(true);
    // } else {
    //   setSubmittingState(false);
    // }
  };

  const getReceivedFullAmount = () => {
    let amount = values?.invoiceList?.reduce(
      (total, val) => total + val.exchanged_payment_due,
      0
    );
    return parseFloat(amount + values.refund_amount).toFixed(2);
  };

  const getcurrencysymble = () => {
    const currency = currencyList.find(
      (item) => item.id === values.globalCurrency
    );
    return currency ? currency.symbol : null;
  };

  const debouncedSetRate = useMemo(
    () =>
      debounce((rate) => {
        if (rate < 0.0000000001) rate = 1;
        if (rate > 9999) rate = 9999;
        setFieldValue('exchangeRate', rate);
      }, 500),
    [setFieldValue]
  );

  return (
    <Fragment>
      {loading ? (
        <Loader />
      ) : (
        <div className="received-payment-form">
          {renderModals()}
          <Form
            className="salesorder-form feilds_so"
            onSubmit={(event) => {
              if (stopRequest === true) event.preventDefault();
              else if (submitFlag === false) {
                event.preventDefault();
                setShowMergeModal(true);
              } else {
                formSubmit(event, values.items, setFieldValue, handleSubmit);
              }
            }}
          >
            <FormSection
              title={`${
                type === 'add'
                  ? t('Payments.add')
                  : type === 'edit'
                  ? 'Edit'
                  : 'Clone'
              } ${t('Payments.payment')}`}
            >
              <div className="two-fields-row">
                <div className="">
                  <Field
                    type="DynamicPaginationDropdown"
                    name={t('Payments.customer_name')}
                    id="contactId"
                    clearable={true}
                    value={values.contactId}
                    newCust={currentCustomer}
                    editCust={values.contactObj}
                    handleChange={(option) => {
                      if (option?.value === 'createNew') {
                        setStatus({ ...status, showContactCreateModal: true });
                      } else {
                        customerChangeHandler(option?.value);
                      }
                    }}
                    required
                    addButton
                    alphabetSort
                    error={touched.contactId && errors.contactId}
                    placeholder={'Select'}
                    onBlur={() => {
                      setFieldTouched('contactId', true);
                    }}
                    api="advancepayment/contact"
                    disabled={type === 'edit' || comingFromContact}
                  />
                  {/* <Field
                className="w-100"
                type="PaginationDropdown"
                name="Customer Name"
                placeholder="Select Customer"
                autoFocus={true}
                clearable={false}
                id="contactId"
                value={values.contactId}
                options={customerList}
                dropdownValue="id"
                dropdownLabel="display_name"
                addButton
                required
                onBlur={handleBlur}
                error={touched.contactId && errors.contactId}
                size="large"
                handleChange={(option) => {
                  if (option.value === 'createNew') {
                    setStatus({ ...status, showContactCreateModal: true });
                  } else {
                    customerChangeHandler(option.id);
                  }
                }}
                disabled={type === 'edit' || comingFromContact}
              /> */}

                  {values.contactId && (
                    <div className="view-detail">
                      <button
                        type="button"
                        className=""
                        onClick={() => handleCustomerModal(values.contactId)}
                      >
                        {' '}
                        {t('saleOrder.view_details')}
                      </button>
                    </div>
                  )}
                </div>
                <div
                  className={values.contactId ? 'displaying' : 'notdisplaying'}
                >
                  <Field
                    className="inline-field w-100"
                    type="number"
                    size=""
                    name={t('Payments.payment_no')}
                    id="paymentId"
                    placeholder=""
                    value={values.paymentId}
                    handleChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.paymentId && errors.paymentId}
                    disabled
                  />
                </div>
              </div>
              <div
                className={values.contactId ? 'displaying' : 'notdisplaying'}
              >
                <div className="three-fields-row">
                  <Field
                    className=""
                    type="date"
                    name={t('Payments.payment_date')}
                    id="paymentDate"
                    size=""
                    value={values.paymentDate}
                    handleChange={(date) => {
                      setFieldValue('paymentDate', date);
                    }}
                    onBlur={() => setFieldTouched('paymentDate', true)}
                    required
                    error={touched.paymentDate && errors.paymentDate}
                  />
                  <Field
                    className="inline-field"
                    size=""
                    type="dropdown"
                    name={t('Payments.payment_mode')}
                    id="payment_mode"
                    clearable={false}
                    value={values.payment_mode}
                    options={status.paymentMethods}
                    dropdownValue="id"
                    dropdownLabel="name"
                    handleChange={handlePaymentChange}
                    required
                    onBlur={handleBlur}
                    error={touched.payment_mode && errors.payment_mode}
                  />
                </div>

                {/* ////////////Currency Dropdown///////////// */}

                <div className="height" style={{ minHeight: '250px' }}>
                  <div className="three-fields-row currency-field">
                    <div className="flex-50 currency-dropdown payment-current-block">
                      {/* <div className='currency-icon--main'> */}

                      <Field
                        size="large"
                        name="Currency"
                        id="globalCurrency"
                        value={values.globalCurrency || null}
                        options={currencyList}
                        dropdownValue="value"
                        dropdownLabel="label"
                        className=""
                        disabled={
                          status.disable_currency_change ||
                          !permissions?.superAccess
                        }
                        addButton={true}
                        handleChange={(option) => {
                          if (option && option.value === 'createNew') {
                            setStatus({
                              ...status,
                              showCurrencyCreateModal: true,
                            });
                            // setShowCurrencyModal(true);
                            return;
                          }
                          if (option?.value === values.globalCurrency) {
                            return;
                          }
                          setFieldValue('globalCurrency', option?.value);
                          setFieldValue(
                            'exchangeRate',
                            option.exchange_rate || 1
                          );
                        }}
                        onBlur={() => setFieldTouched('currencyId', true)}
                        type="dropdown"
                        // disabled={type === 'edit'}
                        clearable={false}
                        required
                        error={touched.currencyId && errors.name}
                      />
                      {type === 'edit' && status.disable_currency_change && (
                        <ToolTip
                          className="currency-disabled"
                          content="Currency is disabled because payments or refunds are applied. Delete them to enable it."
                        />
                      )}
                      {/* </div> */}
                      {values.globalCurrency &&
                        organizationCurrency.id === values.globalCurrency &&
                        organizationCurrency.is_base_currency && (
                          <div
                            style={{ display: 'flex', alignItems: 'center' }}
                            className="bold"
                          >
                            <span
                              class="badge badge-success"
                              style={{
                                backgroundColor: '#a8e6a1',
                                color: 'black',
                                marginTop: '0',
                              }}
                            >
                              {' '}
                              {t('common.baseCurrency')}
                            </span>
                          </div>
                        )}
                    </div>
                    <div className="so-form-inner">
                      <div className="middle-row">
                        {values.globalCurrency &&
                          organizationCurrency?.id !==
                            values.globalCurrency && (
                            <>
                              <Field
                                name="Exchange Rate"
                                className="float-right bold"
                                type="number"
                                prefix={getcurrencysymble()}
                                value={parseFloat(
                                  values?.exchangeRate || values?.exchange_rate
                                )}
                                decimalScale={6}
                                disabled={
                                  status.disable_currency_change ||
                                  !permissions?.superAccess
                                }
                                allowNegative
                                id="exchangeRate"
                                placeholder={getcurrencysymble() + '1'}
                                thousandSeparator=","
                                onValueChange={(value) => {
                                  debouncedSetRate(value.floatValue);
                                }}
                                onBlur={handleBlur}
                                error={
                                  touched?.exchangeRate && errors?.exchangeRate
                                }
                              />
                              &nbsp; &nbsp; &nbsp;
                              <CurrencyRateTiles
                                // currentCurrency={current_currency}
                                // currency={organizationCurrency}
                                currentCurrency={current_currency}
                                setFieldValue={setFieldValue}
                                currency={organizationCurrency}
                                values={values}
                              />
                            </>
                          )}
                      </div>
                    </div>
                    {/* ////////////Currency Dropdown Ends///////////// */}
                  </div>

                  {/* //////////// Exchange Rate start //////////// */}
                  <div
                    className="flex-50 right-column"
                    style={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    <div className="amount-received">
                      <Field
                        className=""
                        size=""
                        type="number"
                        name={t('Payments.amount_received')}
                        id="amount_received"
                        placeholder="0"
                        value={(
                          values.amount_received * (values.exchangeRate || 1)
                        ).toFixed(2)}
                        onValueChange={(val) => {
                          handleAdjustmentChange(val);
                        }}
                        prefix={getcurrencysymble()}
                        decimalScale={2}
                        onBlur={handleBlur}
                        required
                        allowNegative={false}
                        thousandSeparator=","
                        error={
                          touched.amount_received && errors.amount_received
                        }
                        disabled={fullAmountRec}
                        removeValueOnClick
                        selectOnFocus
                      />
                      <div>
                        <input
                          type="checkbox"
                          className="view-details-btn"
                          id="check"
                          onChange={handleReceivedAmount}
                          checked={fullAmountRec}
                        />
                        <label
                          style={{ cursor: 'pointer', paddingLeft: '5px' }}
                          htmlFor="check"
                        >
                          {`${t(
                            'Payments.received_full_amount'
                          )} ( ${getcurrencysymble()}${(
                            values?.total_received_full_amount *
                              (values.exchangeRate || 1) || 0
                          )?.toFixed(2)})`}
                        </label>
                      </div>
                    </div>

                    {values.globalCurrency &&
                      organizationCurrency.id !== values.globalCurrency && (
                        // organizationCurrency.is_base_currency &&
                        <div className="amount-received">
                          <Field
                            name="Amount Received (Base Currency)"
                            className="bold"
                            type="number"
                            prefix={organizationCurrency.symbol}
                            value={parseFloat(
                              ((values.amount_received || 0) *
                                (values.exchangeRate || 1)) /
                                (values.exchangeRate || 1)
                            ).toFixed(2)}
                            decimalScale={2}
                            allowNegative
                            id="exchangeRateValue"
                            placeholder={organizationCurrency.symbol + '0'}
                            thousandSeparator=","
                            disabled
                          />
                          <div style={{ marginTop: '6px' }}>
                            <label
                              style={{
                                cursor: 'pointer',
                                paddingLeft: '5px',
                              }}
                            >
                              {`${t('Payments.received_full_amount')}  (${
                                organizationCurrency.symbol
                              }${(
                                values?.total_received_full_amount || 0
                              )?.toFixed(2)})`}
                            </label>
                          </div>
                        </div>
                      )}
                  </div>

                  {/* //////////// Exchange Rate ends //////////// */}
                </div>
                {
                  <p className="feature-note">
                    <strong>Caution:&nbsp;</strong>Changing the <b>Currency</b>{' '}
                    or <b>Exchange Rate</b> will trigger recalculations for all
                    related amount fields. Please review and verify them again.
                  </p>
                }
                <div className="so-form-inner">
                  <div className="middle-row">
                    <Field
                      className="inline-field description_box "
                      size="large"
                      type="textarea"
                      name={t('Payments.customer_notes')}
                      value={values.customerNotes}
                      id="customerNotes"
                      handleChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.customerNotes && errors.customerNotes}
                    />
                  </div>
                  <Field
                    className="inline-field"
                    name={t('Payments.reference')}
                    size="large"
                    id="reference"
                    value={values.reference}
                    handleChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.reference && errors.reference}
                  />
                </div>
                <div className="form-field">
                  <div className="table-title mb_3 d-flex align-center">
                    <div className="d-flex payment-invoice-main">
                      <label className="semi-bold">
                        {t('Payments.select_invoices')}
                      </label>{' '}
                      <span className="icon_div d-flex align-center">
                        <MdHelpOutline
                          className="material-icon blue-icon help"
                          style={{ marginRight: '1.7rem' }}
                        />
                        <div className="tooltip_tooltip">
                          {t('Payments.note_entered_payment')}
                        </div>
                      </span>
                      <button
                        type="button"
                        className="buttonDateRangeFilter"
                        style={{
                          marginRight: '10px',
                        }}
                        onClick={() => setDataRangeModal(true)}
                      >
                        {invoiceFilterDate.displayDateText}
                      </button>
                      &nbsp;
                      {invoiceFilterDate.displayDateText !==
                        `(${t('Payments.date_filter')})` && (
                        <button
                          type="button"
                          className="buttonDateRangeFilter"
                          onClick={() => dateRangeFilterHandler('reset')}
                        >
                          {t('Payments.reset')}
                        </button>
                      )}
                    </div>
                    <button onClick={handleClearAmount}>
                      {t('Payments.clear_applied_amount')}
                    </button>
                  </div>

                  {loadingItem && <Loader />}

                  {/* <span
                onClick={() => {
                  setDataRangeModal(true);
                }}
              >
                Date Filter
              </span> */}

                  {dateRangeLoader ? <Loader /> : renderList()}
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  {renderSummary()}
                </div>

                {values.contactId && (
                  <FormAction
                    className="So-actions payment-actions"
                    disabled={
                      SubmittingState || isSubmitting || disabled
                      // disableCheck
                    }
                    saveBtnFlag
                    onSubmit={handleSubmit}
                    onCancel={() => {
                      let dataFromLS = getObjFromLS('module');
                      let redirectUrl = '';

                      if (dataFromLS.moduleName === 'contacts') {
                        history.push('/contacts');
                        return;
                      }

                      if (
                        window.location.pathname.includes('add') ||
                        window.location.pathname.includes('edit')
                      ) {
                        history.push('/paymentsmade' + redirectUrl);
                      } else {
                        setObjInLS('module', {
                          ...dataFromLS,
                          action: null,
                        });
                        history.push('/r');
                      }
                    }}
                    isSalesOrder={true}
                    isSO
                    dropUpSO={[
                      {
                        label: t(
                          'saleOrder.save_button_options.save_and_print'
                        ),
                        onClick: (event) => {
                          setstopRequest(true);
                          handleSaveAndPrint(event, submitFlag);
                          //   handleSubmit();
                        },
                        disabled:
                          SubmittingState ||
                          isSubmitting ||
                          disabled ||
                          disableCheck,
                      },
                      {
                        label: t('saleOrder.save_button_options.save_and_send'),
                        onClick: (event) => {
                          setstopRequest(true);
                          handleSaveAndSend(event, submitFlag);
                          //   handleSubmit();
                        },
                        disabled:
                          SubmittingState ||
                          isSubmitting ||
                          disabled ||
                          disableCheck,
                      },
                    ].filter((item) =>
                      hasMobile ? item.label !== 'Save & Print' : item
                    )}
                    additionalFields={[
                      {
                        label: t('saleOrder.save_button_options.save_and_send'),
                        onClick: (event) => {
                          handleSaveAndSend(event, submitFlag);
                          //   handleSubmit();
                        },
                        disabled:
                          SubmittingState ||
                          isSubmitting ||
                          disabled ||
                          disableCheck,
                      },
                      {
                        label: t(
                          'saleOrder.save_button_options.save_and_print'
                        ),
                        onClick: (event) => {
                          handleSaveAndPrint(event, submitFlag);
                          // handleSubmit();
                        },
                        disabled:
                          SubmittingState ||
                          isSubmitting ||
                          disabled ||
                          disableCheck,
                      },
                    ].filter((item) =>
                      hasMobile ? item.label !== 'Save & Print' : item
                    )}
                  />
                )}
              </div>
            </FormSection>
            <ErrorFocus />
          </Form>
        </div>
      )}
    </Fragment>
  );
};

export default formEnhancer(ReceivedPaymentFormEnhancer);

export const CurrencyRateTiles = ({
  currentCurrency,
  setFieldValue,
  currency,
  values,
}) => {
  const setitems = (rate) => {
    // Just update the exchange rate - useEffect will handle conversion
    // No need to manually update items here
  };
  return (
    <table className="currency-table">
      <thead>
        <tr>
          <th></th>
          <th>{currency?.currency_code}</th>
          <th></th>
          <th>{currentCurrency?.currency_code}</th>
          <th></th>
        </tr>
      </thead>

      <tbody>
        {/* System Rate Row */}
        <tr>
          <td className="text-muted">{t('common.systemRate')}</td>
          <td>
            {currency?.symbol}
            {currency?.exchange_rate.toFixed(2)}
          </td>
          <td>=</td>
          <td>
            <span>{currentCurrency?.symbol}</span>&nbsp;
            <span dir="ltr">{currentCurrency?.exchange_rate}</span>
          </td>
        </tr>
        {/* Live Exchange Rate Invoiced Row */}
        <tr>
          <td className="text-muted">{t('common.onlineRate')}</td>
          <td>
            {currentCurrency?.latest_exchange_rate > 0 ? (
              <>
                {currency?.symbol}&nbsp;
                {currency?.exchange_rate.toFixed(2)}
              </>
            ) : (
              '-'
            )}
          </td>
          <td>=</td>
          <td>
            {currentCurrency?.latest_exchange_rate > 0 ? (
              <>
                <span>{currentCurrency?.symbol}</span>&nbsp;
                <span dir="ltr">
                  {currentCurrency?.latest_exchange_rate.toFixed(2)}
                </span>
              </>
            ) : (
              <span dir="ltr">{'-'}</span>
            )}
          </td>
        </tr>
      </tbody>
    </table>
  );
};
